import { EntityType } from '@repo/common/enums/entityType';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { ManageTemplatePage } from './ManageTemplatePage';
import { TemplatesListPage } from './TemplatesListPage';

export const TemplateSettings = observer(() => {
	const navigate = useNavigate();
	const location = useLocation();

	// Use sessionStorage to persist data across remounts
	const getStoredType = (): EntityType => {
		const stored = sessionStorage.getItem('templateSettings_type');
		if (!stored) return EntityType.document;

		const isValid = Object.values(EntityType).includes(stored as EntityType);
		return isValid ? (stored as EntityType) : EntityType.document;
	};

	const getStoredTemplateId = (): string => {
		const stored = sessionStorage.getItem('templateSettings_templateId');
		return stored || '';
	};

	const [type, setType] = useState<EntityType>(getStoredType());
	const [templateId, setTemplateId] = useState<string>(getStoredTemplateId());

	const updateType = (newType: EntityType) => {
		sessionStorage.setItem('templateSettings_type', newType);
		setType(newType);
	};

	const updateTemplateId = (newTemplateId: string) => {
		sessionStorage.setItem('templateSettings_templateId', newTemplateId);
		setTemplateId(newTemplateId);
	};

	if (location.pathname.includes('/templates/manage'))
		return (
			<ManageTemplatePage
				navigate={navigate}
				type={type}
				templateId={templateId}
				setTemplateId={updateTemplateId}
			/>
		);

	return (
		<TemplatesListPage
			navigate={navigate}
			setType={updateType}
			setTemplateId={updateTemplateId}
		/>
	);
});
